import React, { useState } from "react";

import { getCompetitionSlug } from "../../../utils/hooks/event.hooks";
import { useNavigate } from "react-router-dom";
import ChevronRightIconBorder from "../../../assets/icons/chevron-right-icon-border.svg";
import ChevronDownIconBorderBlue from "../../../assets/icons/chevron-down-icon-border-blue.svg";
import {
  useAppDispatch,
  useAppSelector,
  fetchCompetitions,
  fetchEventsByCompetition,
  EventDTO,
  setCompetitionThunk,
  setExchEvent,
  SportSlugById,
  CompetitionDTO,
  getExchangeEvents,
  SPToBFIdMap,
} from "@hypexone/uicore";

interface EventsAccordionProps {
  sportId: string;
  title: string;
}

const EventsAccordion: React.FC<EventsAccordionProps> = ({
  sportId,
  title,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { competitions, events } = useAppSelector((state) => state.catalog);
  const competitionsBySportId = competitions[sportId];
  const {langData} = useAppSelector((state) => state.cms);
  const [openAccordionIndices, setOpenAccordionIndices] = useState<number[]>(
    []
  );
  const [openCompetitionIndices, setOpenCompetitionIndices] = useState<
    string[]
  >([]);

  const toggleAccordion = (index: number) => {
    if (openAccordionIndices.includes(index)) {
      setOpenAccordionIndices(openAccordionIndices.filter((i) => i !== index));
    } else {
      setOpenAccordionIndices([...openAccordionIndices, index]);
      if (!competitionsBySportId) {
        dispatch(fetchCompetitions(sportId));
      }
    }
  };

  const toggleCompetition = (competitionId: string,eventList:any) => {
    if(eventList.length === 0){
      navigate(`/no-markets`);
    }
    if (openCompetitionIndices.includes(competitionId)) {
      setOpenCompetitionIndices(
        openCompetitionIndices.filter((id) => id !== competitionId)
      );
    } else {
      setOpenCompetitionIndices([...openCompetitionIndices, competitionId]);
      if (!events[sportId]) {
        dispatch(fetchEventsByCompetition({ sportId: sportId, competitionId: competitionId, events: []}));
      }
    }
  };

  const handleEventChange = (event: EventDTO) => {
    console.log("Event clicked:", event);
    setCompetitionThunk({
      id: event.competitionId,
      name: event.competitionName,
      slug: getCompetitionSlug(event.competitionName),
    });
    setExchEvent({
      id: event.eventId,
      name: event.eventName,
      slug: event.eventSlug || "",
    });
    navigate(
      event?.providerName?.toLowerCase() === "sportradar" &&
        event?.catId === "SR VIRTUAL"
        ? `/exchange_sports/virtuals/${SportSlugById[event?.sportId]
        }/${getCompetitionSlug(event?.competitionName)}/${event?.eventSlug
        }/${btoa(
          `${event?.sportId}:${event?.competitionId}:${event?.eventId}`
        )}`
        : `/exchange_sports/${SportSlugById[event?.sportId]
        }/${getCompetitionSlug(event?.competitionName)}/${event?.eventSlug
        }/${btoa(
          `${event?.sportId}:${event?.competitionId}:${event?.eventId}`
        )}`
    );
  };

  const renderCompetitions = () => {
    if (!competitionsBySportId || competitionsBySportId.length === 0) {

      return (
        <div className="text-xs bg-gray1 border-b-2 border-b-white pl-4 pr-2 py-1">
          {langData?.['no_competitions_available']||"No competitions available"}
        </div>
      );
    }

    return competitionsBySportId.map((competition: CompetitionDTO, idx) => {
      const eventList: EventDTO[] = getExchangeEvents(
        events,
        SPToBFIdMap[sportId] ? SPToBFIdMap[sportId] : sportId,
        competition.id?.split(":").join("_")
      );

      return (
        <div key={competition.id + idx} className="text-xs">
          <div
            className="flex justify-between cursor-pointer bg-gray1 border-b-2 border-b-white pl-4 pr-2 py-1"
            onClick={() => toggleCompetition(competition.id,eventList)}
          >
            <span className="flex flex-1">{competition.name}</span>
            <span className="flex flex-0">
              {openCompetitionIndices.includes(competition.id) ? (
                <ChevronDownIconComponent />
              ) : (
                <ChevronRightIconComponent />
              )}
            </span>
          </div>
          {openCompetitionIndices.includes(competition.id) &&
            eventList?.map((event: EventDTO) => (
              <div
                key={event.eventId}
                className="flex gap-[2px] pl-6 py-1 bg-gray17 border-b-2 border-b-white cursor-pointer"
                onClick={() => handleEventChange(event)}
              >
                {event.eventName}
              </div>
            ))}
            {
              eventList?.length === 0 && openCompetitionIndices.includes(competition.id) && (
                <div className="text-xs bg-gray1 pl-6 flex text-center border-b-2 border-b-white pl -6 pr-2 py-1">
                  {langData?.['no_events_available']||"No events available"}
                </div>
              )
            }
        </div>
      );
    });
  };

  return (
    <div className="text-[13px]">
      <div
        onClick={() => toggleAccordion(0)}
        className="flex justify-between items-center py-1.5 cursor-pointer border-b border-b-gray1 px-2 hover:bg-gray1 capitalize"
      >
        <span className="flex flex-1">{title}</span>
        <span className="flex flex-0 mr-1">
          {openAccordionIndices.includes(0) ? (
            <ChevronDownIconComponent /> 
          ) : (
            <ChevronRightIconComponent />
          )}
        </span>
      </div>
      {openAccordionIndices.includes(0) && (
        <div className="">{renderCompetitions()}</div>
      )}
    </div>
  );
};

export default EventsAccordion;

const ChevronDownIconComponent = () => {
  return (
    <img
      src={ChevronDownIconBorderBlue}
      alt="down-icon"
      className="h-[15px] w-[15px]"
    />
  );
};

const ChevronRightIconComponent = () => {
  return (
    <img
      src={ChevronRightIconBorder}
      alt="right-icon"
      className="h-[15px] w-[15px]"
    />
  );
};
